//** lead-source Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getSocials = createAsyncThunk('socialsSlice/getSocials', async () => {
    try {
        let response = await axios.get('/social', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createSocial = createAsyncThunk('socialsSlice/createSocial', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/social', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Social added successfully.');
        dispatch(getSocials());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateSocial = createAsyncThunk('socialsSlice/updateSocial', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/social/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Lead Source updated successfully.');
        await dispatch(getSocials());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateSocialStatus = createAsyncThunk('socialsSlice/updateSocialStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/social/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Social Status updated successfully !');
        dispatch(getSocials());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteSocial = createAsyncThunk('socialsSlice/deleteSocial', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/social/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Social deleted successfully.');
        await dispatch(getSocials());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const socialsSlice = createSlice({
    name: 'socialsSlice',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSocials.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    }
});

export default socialsSlice.reducer;
